import { MapEditState } from 'uf/mapedit/state';
import { UFState } from 'uf/state';

export function getMapEditState(state: UFState): MapEditState {
  return state.mapedit;
}
